module.exports = __webpack_public_path__ + "img/placeholder.af4a9299.png";